export const OrderLabels = {
    V: "V",
    R: "R"
}